import { Grid } from "@material-ui/core";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import LoadingSpinner from "components/LoadingSpinner";
import { activityItemTypeTags } from "features/activity/activityConsts";
import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import AddRule from "features/clients/contracts/MechanicalWorkConfig/AddRule";
import Rule from "features/clients/contracts/MechanicalWorkConfig/components/LotMechanicalConfig/Rule";
import { useGetWashRulesQuery } from "features/clients/contracts/MechanicalWorkConfig/mechanicalsSlice";
import { useEffect, useState } from "react";
import configStyles from "../configStyles";

const useStyles = configStyles;

const WashRules = ({ clientId, onClose, clientLots, mechanicalsRulesToEdit, setMechanicalsRulesToEdit }) => {
    const classes = useStyles();

    let { data: rules, error: mechanicalsRulesError, isLoading: mechanicalsRulesLoading } = useGetWashRulesQuery({ clientId });
    let { data: activityItems, error: activityItemsError, isFetching: isLoadingActivityItems } = useGetAllActivityItemsQuery();
    const basicWash = activityItems?.find(item => item.typeTag == activityItemTypeTags.BasicWash);

    const [filters, setFilters] = useState({})

    useEffect(() => {
        setMechanicalsRulesToEdit(rules?.data ?? []);
    }, [rules]);

    const onCancel = () => {
        setMechanicalsRulesToEdit([...mechanicalsRulesToEdit.filter(l => !l?.isNew)])
    }

    //const filteredData = FilterService.filter(filters, undefined, mechanicalsRulesToEdit, [{ type: 'text', size: 2, key: 'activityId', values: activityItems }]);

    return <Grid container direction='column' spacing={2} >
        <LoadingSpinner loading={mechanicalsRulesLoading} />
        <h3 className={classes.rulesHeader}>Automation Rules</h3>
        <Grid item justifyContent="space-between">
            <AddRule
                clientId={clientId}
                clientLots={clientLots}
                mechanicalsRulesToEdit={mechanicalsRulesToEdit}
                setMechanicalsRulesToEdit={setMechanicalsRulesToEdit}
                presetActivityId={basicWash?.id}
            />
        </Grid>
        <Grid item>
            {
                mechanicalsRulesToEdit?.map(rule => <Rule presetActivityId={basicWash?.id} key={rule.id} rule={rule} onCancel={onCancel} clientLots={clientLots} selectLot showLotInfo />)
            }
            {!(!!mechanicalsRulesToEdit?.length) && <EmptyPlaceholder text="No Rules Defined" />}
        </Grid>

    </Grid>
}
export default WashRules;
